// NAVIGATION
export const HEADER_SIGNUP_BUTTON = 'app-header-signup-button';
export const HEADER_HAMBURGER_BUTTON = 'app-header-hamburger-button';
export const HEADER_CHOOSE_LOCATION = 'app-header-tsm-choose-location';
export const HEADER_VIEW_CART_BUTTON = 'view-cart-button';

// TOASTS
export const TOAST_NEW_ACCOUNT_CREATED = 'toast-new-account-created';
export const TOAST_ITEM_ADDED_TO_CART = 'toast-item-added-to-cart';

// DRAWER
export const DRAWER_ACCOUNT_INFO_BUTTON = 'drawer-account-info-button';

// SIGNUP PAGE
export const SIGNUP_FORM_SCROLL_CONTAINER = 'signup-scroll-container';
export const SIGNUP_FORM_NAME_INPUT = 'signup-name-input';
export const SIGNUP_FORM_EMAIL_INPUT = 'signup-email-input';
export const SIGNUP_FORM_PHONE_INPUT = 'signup-phone-input';
export const SIGNUP_FORM_TERMS_AGREEMENT = 'signup-terms-agreement-checkbox';
export const SIGNUP_SUBMIT_BUTTON = 'signup-submit-button';

// SIGNIN PAGE
export const SIGNIN_FORM_EMAIL_INPUT = 'signin-form-email-input';
export const SIGNIN_SUBMIT_BUTTON = 'signin-submit-button';

// OTP PAGE
export const SIGNIN_OTP_INPUT = 'signin-otp-input';
export const SIGNIN_OTP_PAGE = 'signin-otp-page';

// ACCOUNT INFO PAGE
export const ACCOUNT_INFO_SCROLL_CONTAINER = 'account-info-scroll-container';
export const ACCOUNT_INFO_SIGNOUT_BUTTON = 'account-info-signout-button';
export const ACCOUNT_INFO_SIGNOUT_DIALOG_CONTAINER = 'account-info-signout-dialog-container';

// GENERIC DIALOG
export const GENERIC_DIALOG_CONFIRM_BUTTON = 'generic-dialog-confirm-button';
export const GENERIC_DIALOG_CANCEL_BUTTON = 'generic-dialog-cancel-button';

// MENU
export const MAIN_MENU_PAGE_CONTAINER = 'main-menu-page-container';
export const MENU_TILE_ITEM_AT = (index: number) => `menu-tile-item-at-${index}`;
export const MENU_TILE_LIST = 'menu-tile-list';
export const MENU_PRODUCT_PAGE_PRIMARY_ACTION = 'menu-product-page-primary-action';
export const MENU_PRODUCT_PAGE = 'menu-product-page';

// STORE LOCATOR
export const STORE_LOCATOR_CONTAINER = 'store-locator-container';
export const STORE_LOCATOR_SEARCH_INPUT = 'store-locator-search-input';
export const STORE_LOCATOR_SUGGESTION_AT = (index: number) => `store-locator-suggestion-${index}`;
export const STORE_LOCATOR_STORE_LIST_ITEM_AT = (index: number) =>
  `store-locator-store-list-item-${index}`;
export const STORE_LOCATOR_STORE_LIST_ORDER_BUTTON = 'store-locator-store-list-item-order';

// CART
export const BACK_BUTTON_CART_PAGE = 'back_button_cart_page';
export const USER_POINTS_HEADER = 'user_points_header';
export const CART_PAGE = 'cart-page';
export const DONATION_CONTAINER = 'donation-container';
export const DONATION_BUTTON_GROUP = 'donation-button-group';
export const CART_ITEM_DESCRIPTION = 'cart-item-description';
export const CART_ITEM_LABEL = 'cart-item-label';
export const CART_ITEM_PRICE = 'cart-item-price';
export const CART_ITEM_DISCOUNT_PRICE = 'cart-item-discount-price';
export const CART_ITEM_FREE_PRICE = 'cart-item-free-price';
export const SEE_MORE_BUTTON = 'see-more-button';
export const SEE_LESS_BUTTON = 'see-less-button';
export const EDIT_BUTTON = 'edit-button';
export const DELETE_ITEM = 'delete-item';
export const REMOVE_ITEM = 'remove-item';
export const ADD_TO_CART = 'add-to-cart';
export const REWARD_IN_USE = 'reward-in-use';
export const REWARD_AVAILABLE = 'reward-available';
export const REMOVE_REWARD = 'remove-reward';
export const SEE_CHALLENGE_BUTTON = 'see-challenge-button';
export const CHALLENGE_SUCCESS = 'challenge-success';
export const CHALLENGE_WARNING = 'challenge-warning';
export const CHALLENGE_ERROR = 'challenge-error';
export const ADD_MORE_ITEMS_BUTTON = 'add-more-items-button';
export const CART_OFFER_APPLIED = 'cart-offer-applied';
export const REMOVE_CART_OFFER_BUTTON = 'remove-cart-offer-button';
export const OFFERS_AND_PROMOS_LINK = 'offers-and-promos-link';
export const LOYALTY_SAVINGS = 'loyalty-savings';
export const CART_SUBTOTAL = 'cart-subtotal';
export const ORIGINAL_CART_TOTAL = 'original-cart-total';
export const CART_REMOVE_OFFER_MODAL = 'cart-remove-offer-modal';
export const CART_REMOVE_ITEM_MODAL = 'cart-remove-item-modal';
export const CART_PAGE_CONTINUE_BUTTON = 'cart-page-continue-button';

// dynamic cart test Ids
// fresh/cart/src/components/cart-item/item-profile/item-price/index.tsx -  item-price-{cartId}

// CHECKOUT
export const BACK_BUTTON_CHECKOUT_PAGE = 'back-button-checkout-page';
export const CART_PAYMENT_PAGE = 'cart-payment-page';
export const CHECKOUT_SCROLL_VIEW = 'checkout-scroll-view';
export const CLOSE_INLINE_ALERT = 'close-inline-alert';

// Payment Details
export const CHECKOUT_PAYMENT_DETAILS_HEADING = 'checkout-payment-details-heading';
export const CHECKOUT_PAYMENT_METHOD_SELECTOR = 'checkout-payment-method-selector';
export const CHECKOUT_PAYMENT_METHOD_BUTTON = 'checkout-payment-method-button';
export const PAYMENT_METHOD_SELECTION_SHEET = 'payment-method-selection-sheet';
export const PAYMENT_ENTRY_GOOGLE_PAY = 'payment-entry-google-pay';
export const PAYMENT_ENTRY_APPLE_PAY = 'payment-entry-apple-pay';
export const PAYMENT_ENTRY_SAVED_CARD = 'payment-entry-saved-card';
export const PAYMENT_ENTRY_GIFT_CARD = 'payment-entry-gift-card';
export const PAYMENT_ENTRY_ADD_NEW_CARD = 'payment-entry-add-new-card';
export const PAYMENT_ENTRY_ADD_NEW_GIFT_CARD = 'payment-entry-add-new-gift-card';

// New Card Form
export const NEW_CARD_FORM_CONTAINER = 'new-card-form-container';
export const CREDIT_CARD_FORM_NAME_INPUT = 'credit-card-form-name-input';
export const CREDIT_CARD_FORM_NUMBER_INPUT = 'credit-card-form-number-input';
export const CREDIT_CARD_FORM_EXPIRY_INPUT = 'credit-card-form-expiry-input';
export const CREDIT_CARD_FORM_CVV_INPUT = 'credit-card-form-cvv-input';
export const CREDIT_CARD_FORM_POSTAL_CODE_INPUT = 'credit-card-form-postal-code-input';
export const CREDIT_CARD_FORM_SAVE_CARD_CHECKBOX = 'credit-card-form-save-card-checkbox';

// Service Mode Details
export const CHECKOUT_SERVICE_MODE_DETAILS = 'checkout-service-mode-details';
export const CHECKOUT_STORE_SECTION = 'checkout-store-section';
export const CHECKOUT_SERVICE_MODE_PICKER = 'checkout-service-mode-picker';
export const CHECKOUT_PICKUP_TIME_SECTION = 'checkout-pickup-time-section';
export const CHECKOUT_PICKUP_TIME_BUTTON = 'checkout-pickup-time-button';
export const CHECKOUT_NO_REFUND_CALLOUT = 'checkout-no-refund-callout';
export const CHECKOUT_STORE_TOO_FAR_CALLOUT = 'checkout-store-too-far-callout';

// Pickup Time Selector
export const PICKUP_TIME_SELECTOR_SHEET = 'pickup-time-selector-sheet';
export const PICKUP_TIME_SELECTOR_HEADING = 'pickup-time-selector-heading';
export const PICKUP_TIME_SELECTOR_CLOSE_BUTTON = 'pickup-time-selector-close-button';
export const PICKUP_TIME_SELECTOR_DAY_PICKER = 'pickup-time-selector-day-picker';
export const PICKUP_TIME_SELECTOR_TIME_PICKER = 'pickup-time-selector-time-picker';
export const PICKUP_TIME_SELECTOR_CONTINUE_BUTTON = 'pickup-time-selector-continue-button';
export const PICKUP_TIME_SELECTOR_NEXT_DAY_WARNING = 'pickup-time-selector-next-day-warning';
export const NAVIGATE_TO_STORE_LOCATOR = 'navigate-to-store-locator';
export const OPEN_PICKUP_TIME_MODAL = 'open-pickup-time-modal';

// Delivery Details
export const CHECKOUT_DELIVERY_ADDRESS = 'checkout-delivery-address';
export const CHECKOUT_DELIVERY_ETA = 'checkout-delivery-eta';
export const CHECKOUT_DELIVERY_FORM = 'checkout-delivery-form';
export const CHECKOUT_DELIVERY_PHONE_INPUT = 'checkout-delivery-phone-input';
export const CHECKOUT_DELIVERY_UNIT_NUMBER_INPUT = 'checkout-delivery-unit-number-input';
export const CHECKOUT_DELIVERY_INSTRUCTIONS_INPUT = 'checkout-delivery-instructions-input';
export const CHECKOUT_DELIVERY_SAVE_ADDRESS_CHECKBOX = 'checkout-delivery-save-address-checkbox';
export const PHONE_NUMBER_STATEMENT = 'phone-number-statement';
export const SAVE_ADDRESS_STATEMENT = 'save-address-statement';

// Order Summary
export const CHECKOUT_ORDER_SUMMARY_HEADING = 'checkout-order-summary-heading';
export const CHECKOUT_ORDER_SUMMARY_SUBTOTAL = 'checkout-order-summary-subtotal';
export const CHECKOUT_ORDER_SUMMARY_DONATION = 'checkout-order-summary-donation';
export const CHECKOUT_ORDER_SUMMARY_DISCOUNT = 'checkout-order-summary-discount';
export const CHECKOUT_ORDER_SUMMARY_TAX = 'checkout-order-summary-tax';
export const CHECKOUT_ORDER_SUMMARY_DELIVERY_FEES = 'checkout-order-summary-delivery-fees';
export const CHECKOUT_ORDER_SUMMARY_DELIVERY_GEOGRAPHICAL_FEE =
  'checkout-order-summary-delivery-geographical-fee';
export const CHECKOUT_ORDER_SUMMARY_DELIVERY_LONG_DISTANCE_FEE =
  'checkout-order-summary-delivery-long-distance-fee';
export const CHECKOUT_ORDER_SUMMARY_DELIVERY_BASE_FEE = 'checkout-order-summary-delivery-base-fee';
export const CHECKOUT_ORDER_SUMMARY_TIP = 'checkout-order-summary-tip';
export const CHECKOUT_ORDER_SUMMARY_TOTAL = 'checkout-order-summary-total';
export const CHECKOUT_DELIVERY_FEES_MODAL = 'checkout-delivery-fees-modal';
export const SHOW_DELIVERY_FEE_INFO = 'show-delivery-fee-info';
export const CLOSE_DELIVERY_FEE_MODAL = 'close-delivery-fee-modal';
export const CUSTOM_MONETARY_INPUT = 'custom-monetary-input';

// Place Order Button
export const CART_PLACE_ORDER_BUTTON = 'cart-place-order-button';
export const CHECKOUT_PAYMENT_ERROR_ALERT = 'checkout-payment-error-alert';
export const CHECKOUT_PRICING_ALERT = 'checkout-pricing-alert';

// Savings Banner
export const CHECKOUT_SAVINGS_BANNER = 'checkout-savings-banner';

// Legacy
export const CART_SELECT_PAYMENT_METHOD = 'select-payment-method';
export const CART_PAYMENT_PAGE_PAYMENT_METHODS_TOGGLE_BUTTON =
  'cart-payment-page-payment-methods-toggle-button';
export const ADD_NEW_CARD_BUTTON = 'add-new-card-button';
export const CART_STORE_CONFIRMATION_PAGE = 'cart-store-confirmation-page';

// ORDER CONFIRMATION
export const ORDER_CONFIRMATION_PAGE = 'order-confirmation-page';
